import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LabelRightService } from './label-right.service';
import { sessionStorageObject, userRoles } from '../utils/constants';

@Injectable({
  providedIn: 'root'
})
export class MetricsGuard implements CanActivate {
constructor(private router: Router, private labelRightService: LabelRightService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const role = sessionStorage.getItem(sessionStorageObject.role);
      if (role && role === userRoles.labelRightAdminRole) {
        return true;
      }
      this.router.navigate(['']);
      return true;
  }
  
}
